export const prototypeSources = [
  {
    work: "《水浒传》",
    role: "剪影式的配角",
    text:
      "在《水浒传》里，潘金莲属于武松故事线中的关键配角：她嫁与武大郎，又与西门庆私通，最终引来武松复仇。篇幅有限，但情节完整、冲突集中，是后来绝大多数改编的叙事底本。",
    points: ["出场有限但冲击力强", "与西门庆、武大郎、武松构成四角关系", "承担“奸情—复仇”的戏剧结构"],
  },
  {
    work: "《金瓶梅》",
    role: "被展开的主角",
    text:
      "《金瓶梅》借《水浒传》的框架另起炉灶，把潘金莲写成了贯穿全书的中心人物之一。作品补足了她的身世、婚姻与日常，让她从一个象征性的“恶妇”，变成一个活在具体家庭关系里的人。",
    points: ["拥有完整身世与心理", "家庭日常取代英雄复仇", "欲望与经济成为主线"],
  },
  {
    work: "民间讲唱",
    role: "流动的版本",
    text:
      "戏曲、评书与各种说唱艺术在流传中不断改写细节，有的突出因果报应，有的偏向苦情。这些版本一起构成了潘金莲故事的“活水”，也让后世改编有了极大的再创造空间。",
    points: ["情节随剧种变化", "报应与苦情两条路径", "为影视改编提供养分"],
  },
];

export const historyViews = [
  {
    label: "文学人物",
    heading: "潘金莲首先是虚构的文学形象",
    text:
      "从文本看，潘金莲是《水浒传》与《金瓶梅》中的人物，她的性格与命运由作者的叙事安排决定。讨论“她是谁”时，更准确的起点是：她是一个被反复书写的文学角色，而不是有确凿生平记载的历史人物。",
  },
  {
    label: "地方传说",
    heading: "清河一带的“武植”传说",
    text:
      "在河北清河等地的民间流传中，有一种说法认为武大郎的原型是一位身材高大、为官清廉的人，其妻潘氏也颇为贤惠，只因遭人编排才被写进小说。需要说明的是，这属于民间传说与地方讲述，目前尚缺乏可以确证的史料支撑。",
  },
  {
    label: "考据的边界",
    heading: "如何面对“历史真实形象”",
    text:
      "面对“潘金莲历史真实形象”这一说法，更稳妥的态度是区分层次：文学形象有明确出处，地方传说有其流传脉络，而“史实”则需要史料证据。把传说当作已证实的事实，反而会模糊两者之间的界线。",
  },
];